import { render, staticRenderFns } from "./SignGrant.vue?vue&type=template&id=4b311119&scoped=true&"
import script from "./SignGrant.vue?vue&type=script&lang=js&"
export * from "./SignGrant.vue?vue&type=script&lang=js&"
import style0 from "./SignGrant.vue?vue&type=style&index=0&id=4b311119&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b311119",
  null
  
)

export default component.exports